import React, { useEffect, useMemo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import validate from 'validate.js';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import { enqueueSnackbar } from 'actions';
import clsx from 'clsx';
import moment from 'moment';
import {
	Button, TextField, Card, Grid, CardHeader,
	CardContent, Tabs, Tab, Typography, Box, Divider,
	FormControlLabel, Checkbox
} from '@mui/material';
import _ from 'underscore';
import { SelectField } from 'components';
import DatePicker from 'components/DatePicker/DatePicker';
import DateTimePicker from 'components/DatePicker/DateTimePicker';
import TimePicker from 'components/DatePicker/TimePicker';

import {
	SetFormState,
	GetClustersNames,
	GetSuperClusters,
	GetClusterDetails
} from '../../actions/ReportsKpisActions';

const schema = {
	siteId: {
		presence: { allowEmpty: false, message: 'is required' }
	},
	// date: {
	// 	presence: { allowEmpty: false, message: 'is required' }
	// },
	// status: {
	// 	presence: { allowEmpty: false, message: 'is required' }
	// }
};

const useStyles = makeStyles(theme => ({
	root: {},
}));

const ReportsKpisDialogForm = (props) => {
	const { className, ...rest } = props;
	const classes = useStyles();
	const dispatch = useDispatch();
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector(state => state.reportsKpisReducer.formState);
	const userId = useSelector(state => state.session.user.id);
	const userRole = useSelector(state => state.session.user.role);
	const _hasError = field => !!(formState.touched[field] && formState.errors[field]);
	const clustersNames = useSelector((state) => state.reportsKpisReducer.clustersNames);

	const hosts = [
		{ value: 'Vodafone', text: 'Vodafone' },
		{ value: 'Three', text: 'Three' },
		{ value: 'VMO2', text: 'VMO2' }
	];

	const searchTypes = [
		{ value: 'SuperCluster', text: 'SuperCluster' },
		{ value: 'ClusterName', text: 'ClusterName' },
		{ value: 'Date', text: 'Date' }
	];

	const _handleChange = event => {

		setFormState({
			...formState,
			values: {
				...formState.values,
				[event.target.name]:
					event.target.type === 'checkbox'
						? event.target.checked
						: event.target.value
			},
			touched: {
				...formState.touched,
				[event.target.name]: true
			}
		});

		if (event.target.name === 'host') {
			dispatch(GetClustersNames(userId, event.target.value));
		}


		// if (event.target.name === 'searchType') {
		// 	if (event.target.value === 'ClusterName') {
		// 		dispatch(GetClusterDetails(userId, formState.values.clusterName, formState.values.host));
		// 	} else if (event.target.value === 'Date') {
		// 		setFormState({
		// 			...formState,
		// 			values: {
		// 				...formState.values,
		// 				'mocnActivationDateA': null
		// 			}
		// 		});
		// 	}
		// }
	};

	useEffect(() => {
		if (formState.values.searchType === 'SuperCluster') {
			dispatch(GetSuperClusters(userId));
		}
	}, [formState.values.searchType]);

	const _handleChangeCheckbox = event => {

		console.log(event.target.name);
		console.log(event.target.value);

		setFormState({
			...formState,
			values: {
				...formState.values,
				[event.target.name]:
					event.target.type === 'checkbox'
						? event.target.checked
						: event.target.value
			},
			touched: {
				...formState.touched,
				[event.target.name]: true
			}
		});

		if (event.target.name === 'host') {
			dispatch(GetClustersNames(userId, event.target.value));
		}

		// if (event.target.name === 'searchType') {
		// 	if (event.target.value === 'ClusterName') {
		// 		dispatch(GetClusterDetails(userId, formState.values.clusterName, formState.values.host));
		// 	} else if (event.target.value === 'Date') {
		// 		setFormState({
		// 			...formState,
		// 			values: {
		// 				...formState.values,
		// 				'mocnActivationDateA': null
		// 			}
		// 		});
		// 	}
		// }
	};

	useMemo(() => {

		if (formState.values.searchType === 'ClusterName') {
			dispatch(GetClusterDetails(userId, formState.values.clusterName, formState.values.host));
		} else if (formState.values.searchType === 'Date') {
			setFormState({
				...formState,
				values: {
					...formState.values,
					'mocnActivationDateA': undefined
				}
			});
		}
	}, [formState.values.searchType]);

	useMemo(() => {
		setFormState({
			...formState,
			values: {
				...formState.values,
				'clusterName': undefined
			}
		});
	}, [clustersNames]);

	return (
		<div {...rest} className={clsx(classes.root, className)}>
			<Grid container spacing={2}>
				<Grid item md={12} xs={12}>
					<Card>
						<CardHeader title="Reports" style={{ paddingBottom: 0 }} />
						<CardContent>
							<Grid container spacing={2}>
								<Grid item md={2} xs={2}>
									<SelectField
										id="host"
										name="host"
										hintText="Host"
										defaultValue=""
										menuItems={(hosts) || []}
										value={formState.values.host}
										onChange={_handleChange}
										sx={{
											'& .MuiInputBase-input': {
												backgroundColor: 'white',
												'&.Mui-disabled': {
													color: 'dimGray',
													WebkitTextFillColor: 'dimGray'
												}
											},
										}}
									/>
								</Grid>
								<Grid item md={3} xs={3}>
									<SelectField
										id="searchType"
										name="searchType"
										hintText="Search Type"
										defaultValue=""
										menuItems={(searchTypes) || []}
										value={formState.values.searchType}
										onChange={_handleChange}
										sx={{
											'& .MuiInputBase-input': {
												backgroundColor: 'white',
												'&.Mui-disabled': {
													color: 'dimGray',
													WebkitTextFillColor: 'dimGray'
												}
											},
										}}
									/>
								</Grid>
								<Grid item md={3} xs={3}>
									<FormControlLabel
										name="exportCellsDetails"
										control={<Checkbox />}
										label="Export Cells Details"
										onChange={_handleChangeCheckbox}
									/>
								</Grid>
								<Grid item md={3} xs={3}>
									<FormControlLabel
										name="exportTopOffendersDetails"
										control={<Checkbox />}
										label="Export Top Offenders"
										onChange={_handleChangeCheckbox}
									/>
								</Grid>
								{/* <Grid item md={3} xs={3}>
									<SelectField
										id="clusterName"
										name="clusterName"
										hintText="Cluster Name"
										defaultValue=""
										menuItems={(clustersNames) || []}
										value={formState.values.clusterName}
										onChange={_handleChange}
										error={
											_hasError('clusterName')
												? formState.errors.clusterName[0]
												: null
										}
										sx={{
											'& .MuiInputBase-input': {
												backgroundColor: 'white',
												'&.Mui-disabled': {
													color: 'dimGray',
													WebkitTextFillColor: 'dimGray'
												}
											},
										}}
										disabled={formState.values.host === undefined}
									/>
								</Grid> */}
								{/* <Grid item md={2} xs={2}>
									<Button
										onClick={_generateReport}
										color="secondary"
										size="small"
										variant="contained"
										style={{ height: '100%' }}
									>
										Generate Report
									</Button>
								</Grid> */}
							</Grid>
						</CardContent>
					</Card>
				</Grid>
			</Grid>
		</div >
	);
};

ReportsKpisDialogForm.propTypes = {
	className: PropTypes.string
};

export default ReportsKpisDialogForm;
